import React from 'react';
import PropTypes from 'prop-types';
import { ReactMobileOverlay } from './ReactMobileOverlay.component';
import { ReactTooltip } from './ReactTooltip.component';

const ReactTooltipManager = ({
  appendTo,
  boundary,
  channel,
  children,
  className,
  closeButton,
  content,
  disableTooltip,
  distance,
  flip,
  interactive,
  maxWidth,
  onShow,
  placement,
  portal,
  showClose,
  visible,
  zIndex
}) => {
  if (disableTooltip) {
    return children;
  }
  if (channel === 'mobile') {
    return (
      <ReactMobileOverlay content={content} portal={portal}>
        {children}
      </ReactMobileOverlay>
    );
  }
  return (
    <ReactTooltip
      appendTo={appendTo}
      boundary={boundary}
      className={className}
      closeButton={closeButton}
      content={content}
      distance={distance}
      flip={flip}
      interactive={interactive}
      maxWidth={maxWidth}
      onShow={onShow}
      placement={placement}
      showClose={showClose}
      visible={visible}
      zIndex={zIndex}
    >
      {children}
    </ReactTooltip>
  );
};

ReactTooltipManager.propTypes = {
  appendTo: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  boundary: PropTypes.string,
  channel: PropTypes.oneOf(['desktop', 'mobile']).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  closeButton: PropTypes.bool,
  content: PropTypes.node.isRequired,
  disableTooltip: PropTypes.bool,
  distance: PropTypes.number,
  flip: PropTypes.bool,
  interactive: PropTypes.bool,
  maxWidth: PropTypes.number,
  onShow: PropTypes.func,
  placement: PropTypes.string,
  portal: PropTypes.bool,
  showClose: PropTypes.bool,
  visible: PropTypes.bool,
  zIndex: PropTypes.number
};

ReactTooltipManager.defaultProps = {
  appendTo: () => document.body,
  boundary: 'window',
  className: '',
  closeButton: false,
  disableTooltip: false,
  distance: 25,
  flip: true,
  interactive: false,
  maxWidth: 500,
  onShow: () => {},
  placement: 'top',
  portal: false,
  showClose: true,
  visible: false,
  zIndex: 9999
};

export { ReactTooltipManager };
